



















import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'DisplaySessionExerciseItem',

  props: {
    item: {
      type: Object,
      required: true,
    },
    selectable: {
      type: Boolean,
      default: false,
    },
    isSelected: {
      type: Boolean,
      default: () => false,
    },
    type: {
      type: String,
      required: true,
    },
  },

  setup(props, { emit }) {
    /**
     * Handler for select event
     * @param {number} id
     * */
    function selectEventHandler(id: number) {
      emit('toggle-select', id);
    }

    /**
     * Handler for remove event
     * @param {number} id
     * */
    function removeEventHandler(id: number) {
      emit('remove-item', { id, type: props.type })
    }

    return {
      selectEventHandler,
      removeEventHandler,
    };
  }
});
